import { render, staticRenderFns } from "./CardLoadingTransparent.vue?vue&type=template&id=63ab615e&scoped=true&"
import script from "./CardLoadingTransparent.vue?vue&type=script&lang=js&"
export * from "./CardLoadingTransparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab615e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCardText,VFlex,VProgressCircular})
